/**
 * News critical-alerts band — follow the listing's filters.
 *
 * THE BUG THIS FIXES: the band (designs/news.html `.news-criticals`) is a separate
 * module around the engine — its own WP_Query, rendered server-side ABOVE the grid — so
 * it never took part in the grid's AJAX filtering. Choosing a category or typing a
 * search left all three alert banners on screen with a frozen count, as if the filters
 * did not apply to them. In the design the criticals carry the same filterable data as
 * every other card and drop out with everything else.
 *
 * Hiding the whole band when any filter is active would be simpler, but WRONG here:
 * NewsIndex excludes critical posts from the grid (`post__not_in`), so a hidden band
 * makes those stories unreachable in a filtered view — including the case where they
 * are exactly what the filter asked for. So each card is matched individually.
 *
 * MATCHED: `news-category` (slug equality) and `search` (substring of the card's title +
 * category + excerpt). NOT matched: `order_by` — the band is capped at three
 * newest-first banners (DEC-006) and re-ordering three cards adds no information.
 *
 * Layering with the "Show critical alerts" checkbox: that toggle owns the band's `d-none`
 * (engine `data-fr-toggles`). This module only ever sets/clears the `hidden` ATTRIBUTE,
 * so the two never fight — the band shows when the checkbox is on AND something matches.
 *
 * @param {*} _s The vanilla-jq helper (window._s).
 */
( function ( _s ) {
	const BAND_CARD = '[data-fr-critical-card]';
	const BAND_PART = '[data-fr-critical-band]';

	/**
	 * Does a card survive the current filters?
	 *
	 * @param {HTMLElement} card   A `[data-fr-critical-card]` banner.
	 * @param {string}      cat    The selected news-category slug ('' = all).
	 * @param {string}      search The search term, already lowercased ('' = none).
	 * @return {boolean} True when the card survives the current filters.
	 */
	const cardMatches = ( card, cat, search ) => {
		if ( cat && ( card.getAttribute( 'data-category' ) || '' ) !== cat ) return false;

		if ( search && ( card.getAttribute( 'data-search' ) || '' ).indexOf( search ) === -1 ) {
			return false;
		}

		return true;
	};

	/**
	 * Apply the filters to the band: hide the cards that don't match, retitle the count,
	 * and hide the band's head + list entirely when nothing matches.
	 *
	 * @param {*}      _self  The listing block.
	 * @param {Object} params The engine's current filter params.
	 * @return {void}
	 */
	const filterBand = ( _self, params ) => {
		const cards = _self.find( BAND_CARD );
		if ( ! cards.length ) return;

		const cat = ( params && params[ 'news-category' ] ) || '';
		//The sidebar's search field is `name="search"` (NOT `query` — an earlier cut of
		//this read `params.query`, so search silently never filtered the band).
		//Lowercased on both sides; `data-search` is already lowercase.
		const search = ( ( params && params.search ) || '' ).toString().trim().toLowerCase();

		let visible = 0;

		cards.each( card => {
			const matches = cardMatches( card, cat, search );

			if ( matches ) {
				card.removeAttribute( 'hidden' );
				visible++;
			} else {
				card.setAttribute( 'hidden', '' );
			}
		} );

		//Count reads "N critical alerts" — the total is the band's own capped query, so
		//there is no "of Y" to show (unlike the grid's count).
		_self.find( '[data-critical-count]' ).each( el => {
			el.textContent =
				visible + ' ' + ( visible === 1 ? 'critical alert' : 'critical alerts' );
		} );

		//Nothing matched → drop the head + list so the section doesn't render as a
		//heading over empty space (the same reason the grid hides its own head).
		_self.find( BAND_PART ).each( el => {
			if ( visible ) {
				el.removeAttribute( 'hidden' );
			} else {
				el.setAttribute( 'hidden', '' );
			}
		} );
	};

	_s.fn.newsCriticalBand = function () {
		return this.each( el => {
			const _self = _s( el );

			if ( ! _self.find( BAND_CARD ).length ) return;

			const _filters = _self.find( '.card-grid-filters' );

			//Follow every filter change the engine announces. No debounce: this is a
			//handful of attribute writes, and it should feel simultaneous with the grid.
			_filters.on( 'fr:filters-changed', e => {
				filterBand( _self, e.detail && e.detail.params );
			} );

			//Initial state — a deep link (?news-category=… / #hash) must arrive filtered,
			//not flash the full band. The engine populates the config on load too.
			_filters.trigger( 'fr:get-filters-config', {
				callback: params => filterBand( _self, params ),
			} );
		} );
	};

	_s( document ).ready( () => {
		_s( '.card-grid-with-filters-module' ).newsCriticalBand();
	} );
} )( window._s );
